import { CitizenQRInfo } from "../types/citizenQRInfo";

// Parser cho định dạng pipe "|"
function parsePipe(text: string): CitizenQRInfo {
  // giữ cả field rỗng (||)
  const tokens = text.split("|").map(t => t.trim());
  // Có 7 field: personalId | oldId | fullName | dob | gender | address | issueDate
  // Có 6 field: personalId | fullName | dob | gender | address | issueDate
  let personalId = tokens[0] ?? "";
  let oldId: string | null = null;
  let fullName = "";
  let dob = "";
  let gender = "";
  let address = "";
  let issueDate = "";

  if (tokens.length >= 7) {
    // có oldId (có thể rỗng)
    oldId = tokens[1] || null;
    fullName = tokens[2] || "";
    dob = normDate(tokens[3] || "");
    gender = normGender(tokens[4] || "");
    address = tokens[5] || "";
    issueDate = normDate(tokens[6] || "");
  } else if (tokens.length >= 6) {
    // không có oldId
    oldId = null;
    fullName = tokens[1] || "";
    dob = normDate(tokens[2] || "");
    gender = normGender(tokens[3] || "");
    address = tokens[4] || "";
    issueDate = normDate(tokens[5] || "");
  } else {
    // thiếu field → fallback tối thiểu
    fullName = tokens[1] || "";
    dob = normDate(tokens[2] || "");
    gender = normGender(tokens[3] || "");
    address = tokens[4] || "";
    issueDate = normDate(tokens[5] || "");
  }

  return {
    personalId: personalId,
    oldId,
    fullName,
    dob,
    gender,
    address: address.replace(/\s+/g, " ").trim(),
    issueDate,
  };
}

// Parser cho định dạng 2 dòng cũ
function parseLegacy(text: string): CitizenQRInfo {
  const lines = text.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
  const line1 = (lines[0] || "").trim();
  const line2 = (lines[1] || "").trim();

  // Dòng 1: "<personalId> <oldId?> <HỌ TÊN...>"
  const p1 = line1.split(/\s+/);
  const personalId = p1[0] || "";
  const oldId = p1.length > 2 ? (p1[1] || null) : null;
  const fullName = p1.slice(oldId ? 2 : 1).join(" ");

  // Dòng 2: "dd/MM/yyyy-G/N-<địa chỉ> / <ngày cấp>"
  const [dobRaw = "", genderRaw = "", addressAndIssueRaw = ""] = line2.split("-");
  let address = "";
  let issueDate = "";

  if (addressAndIssueRaw.includes("/")) {
    const parts = addressAndIssueRaw.split("/");
    issueDate = normDate(parts.pop() || "");
    address = parts.join("/").trim();
  } else {
    address = addressAndIssueRaw.trim();
  }

  return {
    personalId,
    oldId,
    fullName,
    dob: normDate(dobRaw),
    gender: normGender(genderRaw),
    address: address.replace(/\s+/g, " ").trim(),
    issueDate,
  };
}

// Hàm chung: tự nhận biết định dạng
export function parseCitizenQR(decodedText: string): CitizenQRInfo {
  const text = decodedText.trim();
  if (text.includes("|")) {
    return parsePipe(text);
  }
  return parseLegacy(text);
}

function normDate(s: string | undefined | null): string {
  if (!s) return "";
  const t = s.trim();
  // Nếu đã có "/" hoặc "-" thì giữ nguyên (sau khi chuẩn hóa chút)
  if (/^\d{1,2}[\/-]\d{1,2}[\/-]\d{2,4}$/.test(t)) {
    const parts = t.replace(/-/g, "/").split("/");
    const [d, m, y] = parts.map(p => p.padStart(2, "0"));
    const yyyy = (y.length === 2 ? (Number(y) >= 70 ? "19"+y : "20"+y) : y);
    return `${d}/${m}/${yyyy}`;
  }
  // Nếu là DDMMYYYY (8 số) → đổi sang dd/MM/yyyy
  const digits = t.replace(/\D/g, "");
  if (digits.length === 8) {
    const d = digits.slice(0, 2);
    const m = digits.slice(2, 4);
    const y = digits.slice(4);
    return `${d}/${m}/${y}`;
  }
  return t; // fallback
}

function normGender(s: string | undefined | null): string {
  if (!s) return "";
  const v = s.trim().toLowerCase();
  if (["nam", "male", "m"].includes(v)) return "Nam";
  if (["nữ", "nu", "nư", "female", "f"].includes(v)) return "Nữ";
  return s.trim();
}